import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UserMaintenanceModalComponent } from './user-maintenance-modal.component';

@Injectable()
export class UserMaintenanceModalService {

    constructor(private readonly dialog: MatDialog) { }

    showModal() {
        let dialogRef: MatDialogRef<UserMaintenanceModalComponent>;

        dialogRef = this.dialog.open(
            UserMaintenanceModalComponent,
            {
                disableClose: true,
                height: '94vh',
                panelClass: 'tprecm-modal-panel'
            }
        );

        return dialogRef;
    }
}
